/**
 * Whether `url` is a callback to `redirectUri`.
 *
 * Compared by scheme, host and path, because the URL the OS hands to the app is not always
 * the one the IdP redirected to: tu-dortmund.de redirects to www.tu-dortmund.de and
 * appends a trailing slash, and the app is registered for both hosts. So a leading `www.`
 * and trailing slashes are ignored; everything else has to match.
 *
 * Only for recognising the callback — the code exchange must still send `redirectUri`
 * verbatim (RFC 6749 §4.1.3).
 */
export function matchesRedirectUri(url: string, redirectUri: string): boolean {
  let actual: URL;
  let expected: URL;
  try {
    actual = new URL(url);
    expected = new URL(redirectUri);
  } catch {
    return false;
  }

  const host = (u: URL) => u.host.replace(/^www\./, '');
  const path = (u: URL) => u.pathname.replace(/\/+$/, '');

  return actual.protocol === expected.protocol
    && host(actual) === host(expected)
    && path(actual) === path(expected);
}
